import React from 'react'
import NavbarNew from '../components/layout/NavbarNew'
import Aboutus from '../components/sections/Aboutus'
import WhyChooseUs from '../components/sections/WhyChooseUs'
import OurClients from '../components/sections/OurClients'
import Footer from '../components/layout/Footer'
import GetInTouch from '../components/sections/GetInTouch'
import InnerPageHero from '../components/sections/InnerPageHero'
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import AboutUsMain from '../components/sections/AboutUsMain'



function About() {
   const navigate = useNavigate();
  return (
    <div className="app-container">
      {/* <main className="main-content"> */}
      <InnerPageHero 
      title="About Us"
        breadcrumbs={[
          { label: 'Home', href: '/', icon: FaHome ,onClick: () => navigate('/')},
          { label: 'About Us', isCurrentPage: true }
        ]} />
        <AboutUsMain />
      {/* <Aboutus /> */}
      {/* <WhyChooseUs /> */}

      <GetInTouch />
      {/* </main> */}
    </div>
  )
}

export default About
